var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIssueImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_98_1907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125 122.807L125 127.193L-1.9325e-07 199.562L-2.89875e-07 195.176L125 122.807ZM125 118.421L-3.865e-07 190.79L-4.83125e-07 186.404L125 114.035L125 118.421ZM-6.76375e-07 177.632L-5.7975e-07 182.018L125 109.649L125 105.263L-6.76375e-07 177.632ZM-7.73e-07 173.246L-8.69625e-07 168.86L125 96.4914L125 100.877L-7.73e-07 173.246ZM-1.06288e-06 160.088L-9.6625e-07 164.474L125 92.1054L125 87.7195L-1.06288e-06 160.088ZM-1.1595e-06 155.702L-1.25613e-06 151.316L125 78.9475L125 83.3335L-1.1595e-06 155.702ZM-1.44938e-06 142.544L-1.35275e-06 146.93L125 74.5616L125 70.1756L-1.44938e-06 142.544ZM-1.546e-06 138.158L-1.64263e-06 133.772L125 61.4037L125 65.7896L-1.546e-06 138.158ZM-1.83588e-06 125L-1.73925e-06 129.386L125 57.0177L125 52.6317L-1.83588e-06 125ZM-1.9325e-06 120.614L-2.02913e-06 116.228L125 43.8598L125 48.2458L-1.9325e-06 120.614ZM-2.22238e-06 107.456L-2.12575e-06 111.842L125 39.4738L125 35.0879L-2.22238e-06 107.456ZM-2.319e-06 103.07L-2.41563e-06 98.6844L125 26.316L125 30.7019L-2.319e-06 103.07ZM-2.60888e-06 89.9124L-2.51225e-06 94.2984L125 21.93L125 17.544L-2.60888e-06 89.9124ZM-2.7055e-06 85.5265L-2.80213e-06 81.1405L125 8.77209L125 13.1581L-2.7055e-06 85.5265ZM-2.99538e-06 72.3686L-2.89875e-06 76.7545L125 4.38613L125 0.000160217L-2.99538e-06 72.3686ZM125 135.965L125 131.579L-9.6625e-08 203.948L0 208.333L125 135.965Z",
    fill: "url(#paint0_linear_98_1907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 135.965L250 208.334L250 72.3688L125 0.000564575L125 135.965Z",
    fill: "url(#paint1_linear_98_1907)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 195.176L250 199.562L125 127.194L125 122.808L250 195.176ZM250 190.79L125 118.422L125 114.036L250 186.404L250 190.79ZM125 105.264L125 109.65L250 182.018L250 177.632L125 105.264ZM125 100.878L125 96.4918L250 168.86L250 173.246L125 100.878ZM125 87.7199L125 92.1058L250 164.474L250 160.088L125 87.7199ZM125 83.3339L125 78.9479L250 151.316L250 155.702L125 83.3339ZM125 70.176L125 74.562L250 146.93L250 142.544L125 70.176ZM125 65.79L125 61.4041L250 133.772L250 138.158L125 65.79ZM125 52.6321L125 57.0181L250 129.386L250 125L125 52.6321ZM125 48.2462L125 43.8602L250 116.229L250 120.615L125 48.2462ZM125 35.0883L125 39.4742L250 111.843L250 107.457L125 35.0883ZM125 30.7023L125 26.3163L250 98.6847L250 103.071L125 30.7023ZM125 17.5444L125 21.9304L250 94.2987L250 89.9128L125 17.5444ZM125 13.1585L125 8.77249L250 81.1408L250 85.5268L125 13.1585ZM125 0.000564631L125 4.38652L250 76.7549L250 72.3688L125 0.000564631ZM250 208.334L250 203.948L125 131.58L125 135.965L250 208.334Z",
    fill: "url(#paint2_linear_98_1907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 72.3687L125 144.737L125 280.702L-2.99538e-06 208.334L0 72.3687Z",
    fill: "url(#paint3_linear_98_1907)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125 157.895L125 153.509L-1.9325e-07 81.1406L-2.89875e-07 85.5265L125 157.895ZM125 162.281L-3.865e-07 89.9125L-4.83125e-07 94.2985L125 166.667L125 162.281ZM-6.76375e-07 103.07L-5.7975e-07 98.6844L125 171.053L125 175.439L-6.76375e-07 103.07ZM-7.73e-07 107.456L-8.69625e-07 111.842L125 184.211L125 179.825L-7.73e-07 107.456ZM-1.06288e-06 120.614L-9.6625e-07 116.228L125 188.597L125 192.983L-1.06288e-06 120.614ZM-1.1595e-06 125L-1.25613e-06 129.386L125 201.755L125 197.369L-1.1595e-06 125ZM-1.44938e-06 138.158L-1.35275e-06 133.772L125 206.141L125 210.527L-1.44938e-06 138.158ZM-1.546e-06 142.544L-1.64263e-06 146.93L125 219.298L125 214.913L-1.546e-06 142.544ZM-1.83588e-06 155.702L-1.73925e-06 151.316L125 223.684L125 228.07L-1.83588e-06 155.702ZM-1.9325e-06 160.088L-2.02913e-06 164.474L125 236.842L125 232.456L-1.9325e-06 160.088ZM-2.22238e-06 173.246L-2.12575e-06 168.86L125 241.228L125 245.614L-2.22238e-06 173.246ZM-2.319e-06 177.632L-2.41563e-06 182.018L125 254.386L125 250L-2.319e-06 177.632ZM-2.60888e-06 190.79L-2.51225e-06 186.404L125 258.772L125 263.158L-2.60888e-06 190.79ZM-2.7055e-06 195.176L-2.80213e-06 199.562L125 271.93L125 267.544L-2.7055e-06 195.176ZM-2.99538e-06 208.334L-2.89875e-06 203.948L125 276.316L125 280.702L-2.99538e-06 208.334ZM125 144.737L125 149.123L-9.6625e-08 76.7546L0 72.3687L125 144.737Z",
    fill: "url(#paint4_linear_98_1907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 144.737L250 72.3683L250 208.333L125 280.702L125 144.737Z",
    fill: "url(#paint5_linear_98_1907)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 85.5262L250 81.1403L125 153.509L125 157.895L250 85.5262ZM250 89.9122L125 162.281L125 166.667L250 94.2981L250 89.9122ZM125 175.438L125 171.052L250 98.6841L250 103.07L125 175.438ZM125 179.824L125 184.21L250 111.842L250 107.456L125 179.824ZM125 192.982L125 188.596L250 116.228L250 120.614L125 192.982ZM125 197.368L125 201.754L250 129.386L250 125L125 197.368ZM125 210.526L125 206.14L250 133.772L250 138.158L125 210.526ZM125 214.912L125 219.298L250 146.93L250 142.544L125 214.912ZM125 228.07L125 223.684L250 151.316L250 155.702L125 228.07ZM125 232.456L125 236.842L250 164.474L250 160.088L125 232.456ZM125 245.614L125 241.228L250 168.86L250 173.246L125 245.614ZM125 250L125 254.386L250 182.017L250 177.631L125 250ZM125 263.158L125 258.772L250 186.403L250 190.789L125 263.158ZM125 267.544L125 271.93L250 199.561L250 195.175L125 267.544ZM125 280.702L125 276.316L250 203.947L250 208.333L125 280.702ZM250 72.3683L250 76.7543L125 149.123L125 144.737L250 72.3683Z",
    fill: "url(#paint6_linear_98_1907)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_98_1907",
    x: 0,
    y: 0,
    width: 250,
    height: 280.702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2.5 2.5",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 7103
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_98_1907"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_1907",
    x1: 104.167,
    y1: 167.763,
    x2: -9.75663,
    y2: 55.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053A36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_98_1907",
    x1: 135.965,
    y1: 142.544,
    x2: 204.072,
    y2: 56.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00332F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_98_1907",
    x1: 127.193,
    y1: 145.834,
    x2: 237.343,
    y2: 61.4025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053A36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_98_1907",
    x1: 28.7162,
    y1: 86.1494,
    x2: -13.592,
    y2: 255.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00332F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_98_1907",
    x1: 30.4054,
    y1: 92.9062,
    x2: -11.2166,
    y2: 220.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053A36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_98_1907",
    x1: 145.27,
    y1: 141.892,
    x2: 247.525,
    y2: 163.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00332F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_98_1907",
    x1: 138.514,
    y1: 146.96,
    x2: 276.097,
    y2: 157.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053A36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIssueImg);
export default __webpack_public_path__ + "static/media/reportIssueImg.1a5ed4ab0ffbb7e58d6aef26e499b5de.svg";
export { ForwardRef as ReactComponent };